export const filtersTranslationKeys = {
  statisticsFiltersClearAll: 'statistics.filters-clear-all',
  statisticsFiltersApplyFilters: 'statistics.filters-apply-filters',
  filtersTitle: 'postbacks.filters',
}
